/* eslint-disable ember/no-computed-properties-in-native-classes */
import Page from '@linc-technologies/linced-common/models/posts/page';
import { computed } from '@ember/object';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import {
  belongsTo,
  hasMany,
  type AsyncBelongsTo,
  type AsyncHasMany,
} from '@warp-drive/legacy/model';
import type { StatefulArray } from 'ember-data-model-fragments/array/stateful';
import { array } from 'ember-data-model-fragments/attributes';
import type Assessment from '@linc-technologies/linced-common/models/assessments/assessment';
import { resolved } from '@linc-technologies/linced-common/utils/arrays';
import type Person from 'linced-learners/models/person';

// Proto: posts.Page.
export default class _Page extends Page {
  declare [Type]: 'posts/page';

  @belongsTo('person', { async: true, inverse: null })
  declare authorId: AsyncBelongsTo<Person>;

  @hasMany('assessments/assessment', { async: true, inverse: null })
  declare assessmentIds: AsyncHasMany<Assessment>;

  @alias('assessmentIds')
  // @ts-expect-error an alias replaces the common resolved-array getter.
  declare assessments: AsyncHasMany<Assessment>;

  @array('string')
  // @ts-expect-error a stored array replaces the common computed id list.
  declare assessment_ids: StatefulArray<string>;

  @computed('hasAssessments', 'assessments.content.[]')
  get visibleAssessments() {
    if (!this.hasAssessments) {
      return [];
    }
    return resolved(this.assessments).filter(
      (assessment) => assessment.isVisibleToLearners === true,
    );
  }

  // visibleAssessments is a plain array, which has no firstObject.
  @computed('visibleAssessments.[]')
  get firstVisibleAssessment() {
    return this.visibleAssessments[0];
  }
}
